// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--00ee4","description":"styles-module--description--3dd37 p3"};